module.exports = __webpack_public_path__ + "media/images/athletes/928-1f6d3fb7185d8b8b0c4487f8f56676ce.png";